// Module
var code = "<template>\r\n\r\n    <a ref=\"tab_header\" class=\"nav-link nav-item ${class} ${active ? 'active show' : '' } ${disabled? 'disabled':''}\"\r\n       href=\"${href ? href : '#'}\" css=\"${style}\">\r\n        <slot></slot>\r\n    </a>\r\n</template>";
// Exports
export default code;